import common from './common';
import fillApplication from './uae/fillApplication';
import stageResult from './uae/stageResult';
import validation from './validation';
import contract from './uae/contract';
import payment from './uae/payment';
import message from './message';
import servicesConfig from './servicesConfig';
import * as agent from './agent';

import ksaApplication from './ksa/ksaApplication';
import ksaReview from './ksa/ksaReview';
import ksaServices from './ksa/ksaServices';
import ksaOnboarding from './ksa/ksaOnboarding';
import ksaContract from './ksa/ksaContract';
import ksaPayment from './ksa/ksaPayment';
import ksaCompletion from './ksa/ksaCompletion';

export default {
  common,
  fillApplication,
  stageResult,
  validation,
  contract,
  payment,
  message,
  servicesConfig,
  ...agent,

  ksaApplication,
  ksaReview,
  ksaServices,
  ksaOnboarding,
  ksaContract,
  ksaPayment,
  ksaCompletion,
};
